import { useState,useEffect } from "react";
import { Link } from "react-router-dom";
import { HiOutlineMenu, HiOutlineX } from "react-icons/hi";
import { useLocation } from "react-router-dom";
import { PiUserCircleFill } from "react-icons/pi";
import { FaHeart } from "react-icons/fa6";



export default function HeaderDriver() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location=useLocation()

  useEffect(()=>{
  
  },[])

  const links = [
    {name:"خانه",to:"/"},
    {name:"بار",to:"/cargo"},
    {name: "راننده",to:"/driver/cargo"},
    {name:"فروشگاه",to:"/market"},
    {name:"معامله و اجاره خودرو",to:"/ads"},
    {name: "درباره ما",to:"/about"},
    {name:"تماس با ما",to:"/contact"},

  ];

  return (
    <header className="min-w-full bg-white shadow-sm z-50 fixed">
      <div className="flex justify-between items-center px-4 h-[70px]">
        {/* لوگو */}
        <div className="w-[50px] h-full rounded-md overflow-hidden">
          <img
            className="w-full h-full object-contain"
            src="/icon-512.png"
            alt="Logo"
          />
        </div>

        <nav className="hidden md:flex w-full justify-center">
          <ul className="flex gap-8 text-gray-700 text-[12px] lg:text-[16px] ">
          {links.map((item, idx) => {
              const isActive = location.pathname === item.to;
              return (
                <li key={idx} className="relative group">
                  <Link
                    to={item.to}
                    className={`transition-all duration-200 hover:text-special hover:scale-105 
                      ${isActive ? "font-[16px] text-special" : ""}`}
                  >
                    {item.name}
                    <span className="absolute left-0 bottom-0 w-0 h-[2px] bg-special group-hover:w-full transition-all duration-300"></span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>

      
        <div className="hidden md:flex gap-5 items-center text-[12px] pl-5 lg:text-[16px]">
            <Link to={"/driver/dashboard"} className="flex flex-col items-center gap-1 w-max">
                <PiUserCircleFill size={22} className="text-special"></PiUserCircleFill>
                <p className="lg:text-[14px] text-[12px] text-special">حساب کاربری</p>



            </Link>
          
        
        </div>

      
        <div className="md:hidden flex gap-2 items-center">
            <div className=" flex gap-5 items-center text-[12px] lg:text-[16px]">

            <Link to={"/driver/dashboard"} className="flex flex-col items-center   w-max">
                <PiUserCircleFill size={25} className="text-special"></PiUserCircleFill>
        
            </Link>
          
        
        </div>
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="text-gray-700 focus:outline-none text-2xl"
          >
            {mobileOpen ? <HiOutlineX /> : <HiOutlineMenu />}
          </button>
      
        </div>
      </div>

      {/* منو موبایل */}
      {mobileOpen && (
        <nav className="md:hidden bg-white   shadow-md">
          <ul className="flex flex-col gap-4 p-4 text-gray-700 ">
            {links.map((item, idx) => (
              <li onClick={()=>{setMobileOpen(false)}} key={idx} className="h-6 py-1">
                <Link
                  to={item.to}
                  className="block  border-special transition-all duration-200 hover:text-special hover:underline decoration-special underline-offset-4"
                >
                  {item.name}
                </Link>
              </li>
            ))}
      
          </ul>
        </nav>
      )}
    </header>
  );
}
